import { mapGetters, mapActions, mapMutations } from "vuex";

import headerSearch from "@/components/header-search/index.vue";
import headerCatalog from "@/components/header-catalog/index.vue";
import catalogList from "@/components/catalog-list-mobile/index.vue";
import _ from "lodash";
import { globalLoader } from "../../helpers/variables";

export default {
    name: "header-mobile",
    data() {
        return {
            show: false,
            openSelect: false,
        };
    },
    components: {
        "header-search": headerSearch,
        "header-catalog": headerCatalog,
        catalogList,
    },
    computed: {
        ...mapGetters({
            showBasket: "basket/showBasket",
            countBasketItems: `basket/countBasketItems`,
            popupRegister: "auth/popupRegister",
            showPersonalData: "auth/showPersonalData",
            showCatalogMenu: "system/showCatalogMenu",
            isAuthenticated: `auth/isAuthenticated`,
            fixBody: `system/fixBody`,
            querySearch: "search/querySearch",
            resultSearch: "search/resultHeaderSearch",
            searchLoader: "search/headerSearchLoader",
            noResultSearchHeader: "search/noResultSearchHeader",
            showCatalogMenuMobile: "system/showCatalogMenuMobile",
            config: "setting/menu",
            openHeaderMenu: "system/openHeaderMenu",
            recommendedList: `recommendedProduct/recommendedList`,
            countFavouritesItems: `favorites/favouritesListLength`,
            currentBranch: "branches/currentBranch",
            branches: "branches/branchesList",
        }),
        ...mapGetters(["languages", "currentLanguage"]),
    },
    watch: {
        $route() {
            this.hideMobile();
            this.setFocusField(false);
        },
    },
    created() {},
    mounted() {},
    methods: {
        ...mapActions({
            logout: `auth/LOGOUT`,
            fetchSearchTooltip: `search/GET_HEADER_SEARCH_TOOLTIP`,
            fetchSearch: `search/GET_SEARCH_LIST`,
            fetchRecommendedList: `recommendedProduct/GET_RECOMMENDED_LIST`,
        }),
        ...mapMutations({
            changeShowBasket: `basket/CHANGE_SHOW_BASKET`,
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
            changePersonalData: `auth/CHANGE_POPUP_PERSONAL_DATA`,
            changeShowCatalogMenu: `system/CHANGE_SHOW_CATALOG_MENU`,
            changeFixBody: `system/FIX_BODY`,
            reset: `search/RESET_HEADER_SEARCH_TOOLTIP`,
            setQuerySearch: `search/SET_QUERY_SEARCH`,
            changeNoResultSearch: `search/SHOW_NOT_RESULT_SEARCH_HEADER`,
            changeLoader: `search/SET_HEADER_SEARCH_LOADER`,
            changeShowCatalogMenuMobile: `system/CHANGE_SHOW_CATALOG_MENU_MOBILE`,
            changeOpenHeaderMenu: `system/CHANGE_OPEN_HEADER_MENU`,
            resetBasket: "basket/RESET_BASKET",
            setCurrentBranch: "branches/SET_CURRENT_BRANCH",
            changePopupStatus: "branches/OPEN_POPUP_BRANCHES",
        }),
        setBranchId(item) {
            if (item.id !== this.currentBranch.id) {
                localStorage.getItem("products")
                    ? localStorage.setItem(`basket_${this.currentBranch.id}`, localStorage.getItem("products"))
                    : "";
                localStorage.getItem(`basket_${item.id}`)
                    ? localStorage.setItem("products", localStorage.getItem(`basket_${item.id}`))
                    : this.resetBasket();
            }
            this.setCurrentBranch(item);
            localStorage.setItem("branchId", JSON.stringify(item));
            localStorage.setItem("Global-version", 0);

            location.reload();
        },
        openSelectBranch() {
            this.openSelect = !this.openSelect;
        },
        openPopup() {
            this.changePopupStatus(false);
        },
        changeMobile() {
            if (this.openHeaderMenu) {
                this.changeOpenHeaderMenu(false);
                this.changeFixBody(false);
            } else {
                this.changeOpenHeaderMenu(true);
                this.changeFixBody(true);
            }
        },
        userLogout() {
            this.logout();
            this.$router.push({ name: "home" });
        },
        hideMobile() {
            this.changeOpenHeaderMenu(false);
            this.changeFixBody(false);
        },
        changeBasket() {
            this.changeOpenHeaderMenu(false);
            this.changeFixBody(false);
            if (!this.recommendedList) {
                this.fetchRecommendedList();
            }
            this.changeShowBasket(true);
        },
        changeProfile() {
            if (this.isAuthenticated) {
                this.$router.push({ name: "profile-info" }).catch(() => {
                    console.log();
                    this.changeOpenHeaderMenu(false);
                    this.changeFixBody(false);
                });
            } else {
                this.changePopupRegister({ show: true, isRedirect: true });
                this.changeOpenHeaderMenu(false);
                this.changeFixBody(false);
            }
        },
        sendRequest: _.debounce(function() {
            if (this.querySearch.length > 2) {
                this.fetchSearchTooltip(this.querySearch);
            }
        }, 500),
        changeSearch(query) {
            this.setFocusField(true);
            this.setQuerySearch(query);
            this.changeLoader(true);
            this.changeNoResultSearch(false);
            this.reset();
            this.sendRequest();
        },
        setFocusField(status) {
            this.show = status;
        },
        closeResulList() {
            this.setFocusField(false);
        },
        changeShowMobileCatalog() {
            if (this.showCatalogMenu) {
                this.changeShowCatalogMenuMobile(false);
            } else {
                this.changeShowCatalogMenuMobile(true);
            }
        },
        changeLanguage(item) {
            globalLoader(true);
            this.$setLanguage(item.code);
            this.showLangList = false;
            setTimeout(() => {
                globalLoader(false);
            }, 2000);
        },
    },
};
